import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from '../../models/route-redirects';

@Injectable()
export class TwoFactorAuthLoginPageGuard {

    private isTwoFACodeNavigationAllowed: boolean = false;

    constructor(
        private router: Router,

        @Inject(ROUTE_REDIRECTS_TOKEN)
        private routeRedirects: RouteRedirects
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.isTwoFACodeNavigationAllowed
            ? true
            : this.router.parseUrl(this.routeRedirects.LOGIN_ROUTE);
    }

    public setTwoFACodeNavigationAllowed(isAllowed: boolean): void {
        this.isTwoFACodeNavigationAllowed = isAllowed;
    }

}
